/**
* <qr-code :val="val" :size="qrcodeSize" :logo-img="qrcodeLogo" :img-size="imgSize"></qr-code>
* val: qrcode data
* size: qrcode size (Optional, default: 100px)
* img-src: center logo of qrcode (Optional)
* img-size: logo size (Optional)
*
*/
<template>
    <div>
        <canvas
                v-bind:style="{height: size + 'px', width: size + 'px'}"
                :width="size"
                :height="size"
                ref="qr"
        ></canvas>
    </div>
</template>

<script>

  import qr from '~/components/qr/index.js';

  export default {
    props: {
      val: {
        type: String,
        required: true
      },
      size: {
        type: Number,
        default: 100
      },
      // 'L', 'M', 'Q', 'H'
      level: String,
      bgColor: {
        type: String,
        default: '#FFFFFF'
      },
      fgColor: {
        type: String,
        default: '#000000'
      },
      logoImg: {
        type: Object,
        default: null
      },
      imgSize: {
        type: Number,
        default: 30
      }
    },
    watch: {
      size: function(){
        this.update()
      },
      val: function(){
        this.update()
      },
      level: function(){
        this.update()
      },
      bgColor: function(){
        this.update()
      },
      fgColor: function(){
        this.update()
      },
      logoImg(){
        this.update()
      },
      logoSize(_val){
        this.update()
      }
    },
    mounted () {
      this.logoSize = this.imgSize;
      this.logoImage = this.logoImg;
      this.update();
    },
    data(){
      return{
        centerLogo: '',
        logoSize: 0,
        logoImage: null,
        drawLogo: false,
      }
    },
    methods:{
      update () {
        let vm = this;
        let size = vm.size
        let logoSize = vm.logoSize
        let bgColor = vm.bgColor
        let fgColor = vm.fgColor
        let $qr = vm.$refs.qr;

        let qrcode = qr(vm.val)

        let ctx = $qr.getContext('2d')
        let cells = qrcode.modules
        let cellLen = cells.length
        let tileW = size / cells.length
        let tileH = size / cells.length
        let scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx)

        $qr.height = $qr.width = size * scale
        ctx.scale(scale, scale)

        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx.fillStyle = cell ? fgColor : bgColor
            let w = (Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW))
            let h = (Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH))
            ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h)
          })
          if(rdx === cellLen-1){
            vm.drawLogo = true;
          }
        })
        if(!!vm.drawLogo && vm.logoImage){
          vm.$nextTick(function(){
            ctx.drawImage(vm.logoImg, (size/2-logoSize/2), (size/2-logoSize/2), logoSize, logoSize);
          });
        }
      }
    }
  }

  function getBackingStorePixelRatio (ctx) {
    return (
      ctx.webkitBackingStorePixelRatio ||
      ctx.mozBackingStorePixelRatio ||
      ctx.msBackingStorePixelRatio ||
      ctx.oBackingStorePixelRatio ||
      ctx.backingStorePixelRatio ||
      1
    )
  }

</script>

<style>


</style>


// WEBPACK FOOTER //
// components/Qrcode.vue